import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {IconProp} from '@fortawesome/fontawesome-svg-core';
import {FaIconComponent} from '@fortawesome/angular-fontawesome';
import {TranslateModule} from '@ngx-translate/core';

@Component({
    selector: 'app-mfa-addable-device',
    templateUrl: './addable-device.component.html',
    styleUrls: ['./addable-device.component.scss'],
    imports: [FaIconComponent, TranslateModule]
})
export class AddableDeviceComponent implements OnInit {

  @Input() faIcon: IconProp;
  @Input() iconTitle: string;
  @Input() heading: string;
  @Input() description: string;
  @Input() adding: boolean;

  @Output() addClicked = new EventEmitter<MouseEvent>();

  constructor() { }

  ngOnInit(): void {
  }

  onAdd($event: MouseEvent) {
    //Also emit it so the parent container can do anything it needs to like init the form
    this.addClicked.emit($event);
  }

}
